// const FilterTable = (button, table) => {
//   let filter = document.getElementById(button);
//   if (filter) {
//     filter.addEventListener("keyup", (e) => {
//       let srch = filter;
//       let val = srch.value.toLowerCase();
//       let valArr = val.split(" ");
//       let tbl = document.getElementById(table);
//       let tblLength = tbl.rows.length;
//       if (tblLength != 0) {
//         for (let i = 1; i < tblLength; i++) {
//           tbl.rows[i].style.display = "table-row";
//           for (let j = 0; j < valArr.length; j++) {
//             if (
//               tbl.rows[i].textContent.toLowerCase().indexOf(valArr[j]) === -1
//             ) {
//               tbl.rows[i].style.display = "none";
//             }
//           }
//         }
//       }
//     });
//   }
// };

// export { FilterTable };

const FilterTable = (inputId, tableId, buttonClass) => {
  const input = document.getElementById(inputId);
  const table = document.getElementById(tableId);
  const buttons = document.querySelectorAll(buttonClass);

  if (!table) return;

  // 1. Core filtering logic
  const runFilter = (query) => {
    const val = query.toLowerCase().trim();
    const valArr = val === "all" ? [] : val.split(" ");
    const rows = table.getElementsByTagName("tr");

    // Start from 1 to skip the header row
    for (let i = 1; i < rows.length; i++) {
      const rowText = rows[i].textContent.toLowerCase();

      // If "All" is selected or query is empty, show all.
      // Otherwise, check if keywords match.
      const matches = valArr.every((word) => rowText.includes(word));

      rows[i].style.display = matches ? "table-row" : "none";
    }
  };

  // 2. Event Listener for Text Input
  if (input) {
    input.addEventListener("keyup", () => runFilter(input.value));
  }

  // 3. Event Listeners for Buttons
  buttons.forEach((btn) => {
    btn.addEventListener("click", () => {
      const btnText = btn.textContent.trim();

      buttons.forEach((btn) =>
        btn.classList.remove("bg-kensa_lime!", "text-kensa_dark_grey!"),
      );
      btn.classList.add("bg-kensa_lime!", "text-kensa_dark_grey!");

      // Sync the input field for visual feedback (optional)
      if (input) {
        input.value = btnText === "All" ? "" : btnText;
      }

      runFilter(btnText);
    });
  });
};

export { FilterTable };
